import { Table } from "@radix-ui/themes";

interface TableBlockProps {
  headers: string[];
  rows: string[][];
  highlightRules?: Record<string, string>;
}

export function TableBlock({ headers, rows, highlightRules }: TableBlockProps) {
  const getCellClass = (cell: string): string => {
    if (!highlightRules) return "";
    for (const [pattern, className] of Object.entries(highlightRules)) {
      if (cell.toLowerCase().includes(pattern.toLowerCase())) {
        return className;
      }
    }
    return "";
  };

  return (
    <Table.Root variant="surface" size="1" data-testid="table-block">
      <Table.Header>
        <Table.Row>
          {(headers ?? []).map((header, idx) => (
            <Table.ColumnHeaderCell key={idx}>{header}</Table.ColumnHeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {(rows ?? []).map((row, rowIdx) => (
          <Table.Row key={rowIdx}>
            {row.map((cell, cellIdx) => (
              <Table.Cell key={cellIdx} className={getCellClass(cell)}>
                {cell}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
}
